import React, { Component } from "react";

class About extends Component {
  render() {
    let name = "";
    let profilepic = "";
    let bio = "";
    //let street = "";
    let city = "";
    let state = "";
    let zip = "";
    let phone = "";
    let email1 = "";
    let email2 = "";
    let country = "";
    let resumeDownload =
      "https://gitlab.com/mdLima0/docs/-/raw/master/cv/mdlima-resume.web.app_compressed.pdf?inline=false";

    if (this.props.data.basics) {
      name = this.props.data.basics.name;
      profilepic = "images/" + this.props.data.basics.image;
      bio = this.props.data.basics.summary;
      //let street = this.props.data.address.street;
      city = this.props.data.basics.location.city;
      state = this.props.data.basics.location.region;
      zip = this.props.data.basics.location.postalCode;
      country = this.props.data.basics.location.country;
      phone = this.props.data.basics.phone;
      email1 = this.props.data.basics.email1;
      email2 = this.props.data.basics.email2;
      resumeDownload =
        "https://gitlab.com/mdLima0/docs/-/raw/master/cv/mdlima-resume.web.app_compressed.pdf?inline=false";
    }

    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img
              className="profile-pic"
              src={profilepic}
              alt="Nordic Giant Profile Pic"
            />
          </div>
          <div className="nine columns main-col">
            <h2>About Me</h2>

            <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
              {bio}
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>{name}</span>
                  <br />
                  <span>
                    {city}, {country}
                  </span>
                  <br />
                  <span>{phone}</span>
                  <br />
                  <span>{email1}</span>
                  <br />
                  <span>{email2}</span>
                </p>
              </div>
              <div className="columns download">
                <p>
                  <a href={resumeDownload} className="button">
                    <i className="fa fa-download"></i>Download Resume
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
